import { styled } from '@mui/material/styles';
import { Card, CardHeader } from 'shared/mui/Card';
import { Drawer } from 'shared/mui/Drawer/Drawer';

export const FilterDrawerStyled = styled(Drawer)({
  '.MuiBackdrop-root': {
    backgroundColor: 'transparent',
  },
  '.MuiDrawer-paper': {
    top: '48px',
    width: '444px',
    height: 'calc(100% - 48px)',
    boxShadow:
      '0px 9px 46px 8px #0000001F, 0px 24px 38px 3px #00000024, 0px 11px 15px -7px #00000033',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
});

export const CardHeaderStyled = styled(CardHeader)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: '16px 24px',
  flexShrink: 0,
}));

export const CardStyled = styled(Card)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
});
